export class BulletinReport {
    id: number;
    dealerNumber: string;
    bulletinCode: string;
    bulletinDescription: string;
    vehicle: string;
    lastAccess: Date;
    lastUpdate: Date;
    usrLastUpdate: string;
}